





































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {LadingStatus} from "@/enums/status";
import {LadingErrorStatus} from "@/enums/status/ladingerror";

@Component({
    name: "LadingErrorExcel"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, default: () => [] }) dataSource!: any;
    LadingStatus = LadingStatus;
    LadingErrorStatus = LadingErrorStatus;
}
